import { CrudFormConfig, CrudViewFormItemType } from '@rappider/rappider-components/utils';
import { Validators } from '@angular/forms';
import { METADATA_CREATE_FORM_CONFIG } from '../metadata/metadata-create-form-config';

export const TENANT_CREATE_FORM_CONFIG: CrudFormConfig = {
  items: [
    {
      title: 'SHARED.NAME',
      fieldName: 'name',
      type: CrudViewFormItemType.TextBox,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ]
    },
    METADATA_CREATE_FORM_CONFIG
  ]
};
